<script setup>
import ApiKeyRow from "./ApiKeyRow.vue";
import {useQuery} from "@tanstack/vue-query";
import axios from "axios";
import DeleteKeyModal from "../DeleteKeyModal.vue";
import {ref} from "vue";

const keyToDelete = ref();
const showDeleteKeyModal = ref(false);

const {data: apiKeys, isPending, error} = useQuery({
  queryKey: ['api-keys'],
  queryFn: async () => {
    const {data} = await axios.get(`/ajax/v2/api-keys`);
    return data.data;
  },
  refetchOnWindowFocus: false,
  retry: 0 // Prevent default sweet toast from appearing for every retry
});

const confirmDelete = (key) => {
  keyToDelete.value = key;
  showDeleteKeyModal.value = true;
};
</script>

<template>
  <div class="tw-flex">
    <p class="tw-w-1/3 tw-font-bold tw-text-[15px]">
      Manage Keys
    </p>

    <div class="tw-flex tw-flex-col tw-grow tw-bg-neutral-100 tw-rounded-xl tw-px-8 tw-py-6 tw-gap-5">
      <div
        v-if="!apiKeys && isPending"
        class="tw-flex tw-justify-center"
      >
        Fetching API keys
        <svg-vue
          class="tw-h-5 tw-ml-2"
          icon="icons/loading"
        />
      </div>
      <div
        v-if="error"
        class="tw-text-center"
      >
        Something went wrong fetching your API Keys. Please refresh the page or contact support
      </div>
      <div
        v-for="(key, index) in apiKeys"
        v-else
        :key="index"
        class="tw-flex tw-items-center"
      >
        <ApiKeyRow
          :api-key="key"
          @delete="confirmDelete"
        />
      </div>
    </div>
  </div>

  <DeleteKeyModal
    v-if="showDeleteKeyModal"
    :api-key="keyToDelete"
    @close="showDeleteKeyModal = false"
  />
</template>
